import { Grid } from '@mui/material'
import React from 'react'
import { bottomPosition, customStyles } from '../../../styles'
import { MainContainer } from '../../containers'
import { MainButton, MainInput, MainSelect, SubTitle, Title } from '../../helpers'
import { ModalHeader } from '../../modals'

export const OrderInvoice = () => {
    
    const { colors: { main }, buttonSize: { full, large, medium }} = customStyles
  return (
    <MainContainer>
        <ModalHeader text="Detalles del pedido" backward color={ main }/>
        <SubTitle text="Facturar pedido" color={main}/>
        <Grid container spacing={3} mt={3}>
            <MainInput label="Razón social" placeholder="Nombre completo de la persona física o moral" columns={12}/>
            <MainInput label="RFC" placeholder="XAXX010101000" columns={12}/>
            <MainSelect text="Uso de CFDI" columns={12}/>
            <MainInput label="Correo electrónico" placeholder="Nombre completo de la persona física o moral" columns={12}/>
        </Grid>
        <MainButton text="ENVIAR" variant="contained" size={ full } sx={{ marginTop: 30 }}/>
    </MainContainer>
  )
}
